module.exports = __webpack_public_path__ + "img/banner_h5_ls_uy.eacabe89.png";